/* @flow */
// typecheck: ignore file
import CurrentUser from 'auth/CurrentUser';
import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

export function requireFeatures(permissions: string[]) {
  return {
    statics: {
      onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void) {
        const user = CurrentUser.isSignedIn() ? CurrentUser.getUser() : null;
        if (!user) {
          replaceWith('/error');
          return;
        }

        permissions.forEach(permission => {
          if (!user.getFeatures()[permission]) {
            replaceWith('/error');
          }
        });
      },
    },
  };
}

export default requireFeatures;



// WEBPACK FOOTER //
// ./src/components/mixins/RequireFeatures.js